const { StrategyManager } = require("./strategyManager");

function getFeatures(task, simulator) {
    var features = {};
    features.project = {};
    features.resource = {};

    features.project.taskRemainingWork = task.totalWorkHours - task.currWorkedHours;
    features.project.projectTotalRemainingWork = task.project.projectTotalRemainingWork();
    features.project.projectSoonestEndHour = task.project.getMinimumEndHour() - simulator.hoursPassed;
    features.project.projectHoursUntilDeadline = task.project.startHour + task.project.leadTimeHours - simulator.hoursPassed;
    features.project.projectRemainingBuffer = task.project.getDueDate() - task.project.getMinimumEndHour();
    features.project.projectRemainingBufferRatio = features.project.projectRemainingBuffer / task.project.getDueDate();

    var capacities = simulator.resourcePool.getCurrentCapacities();
    //Divide over the numresources available for this
    simulator.resourcePool.resourceGroups.forEach(resourceGroup => {
        // features[resourceGroup.id + "ReadyHours"] /= capacities[resourceGroup.id];
    });

    //Get all the child tasks in the chain, and store them in the dictionary

    var childTasks = task.getAllChildTasks();

    //Calculate how many hours the child task will increase, scaled by 1/numDays from now

    
    
    var readyHours = {};
    var load = {};
    var normalizedDifference = {};
    var importance = {};
    var increaseHours = {};

    //For each resource group, store how many tasks are ready to start
    simulator.resourcePool.resourceGroups.forEach(resourceGroup => {
        readyHours[resourceGroup.id] = 0;
        load[resourceGroup.id] = 0;
        normalizedDifference[resourceGroup.id] = 0;
        importance[resourceGroup.id] = 0;
        increaseHours[resourceGroup.id] = 0;
    });


    for (var childTaskID in childTasks) {
        var childTask = childTasks[childTaskID];
        var daysAway = (childTask.startHour - simulator.hoursPassed) / 8;
        var discreteDaysAway = Math.ceil(daysAway);
        var windowedTaskWorkHours = Math.min(8, childTask.totalWorkHours);
        increaseHours[childTask.resourceGroupID] += windowedTaskWorkHours / discreteDaysAway;
    }

    //Calculate total remaining work for each resource group
    simulator.projectPool.projects.forEach(project => {
        project.taskArray.forEach(task => {
            if(task.isFinished()){ 
                return;
            }
            
            load[task.resourceGroupID] += getLoadRange(task) / capacities[task.resourceGroupID];
        });
    });






    simulator.projectPool.getAllReadyTasks().forEach(task => {
        readyHours[task.resourceGroupID] += getLoadRange(task);
    });

    simulator.resourcePool.resourceGroups.forEach(resourceGroup => { 
        var difference = load[resourceGroup.id] - readyHours[resourceGroup.id];
        normalizedDifference[resourceGroup.id] = difference;
    });
    
    
    
    //Calculate the importance based on the normalizedDifference and the IncreaseHours feature
    simulator.resourcePool.resourceGroups.forEach(resourceGroup => {
        importance[resourceGroup.id] = normalizedDifference[resourceGroup.id] * increaseHours[resourceGroup.id] / 100;
    });
    features.resource = importance;
    

    // console.log({projectIndex: task.project.projectIndex, load: load, readyHours: readyHours, capacities: capacities, normalizedDifference: normalizedDifference, increaseHours: increaseHours, importance: importance})

    //Normalize values to range [0,1]
    // features.taskRemainingWork = features.taskRemainingWork / task.totalWorkHours;
    // features.projectTotalRemainingWork = features.projectTotalRemainingWork / task.project.projectTotalHours();
    // features.projectSoonestEndHour = features.projectSoonestEndHour / task.project.leadTimeHours;
    // features.projectHoursUntilDeadline = features.projectHoursUntilDeadline / task.project.leadTimeHours;
    // features.projectRemainingBuffer = features.projectRemainingBuffer / task.project.leadTimeHours;
    //features.projectRemainingBufferRatio = features.projectRemainingBuffer / task.project.getDueDate();


    return features;
}



function getLoadRange(task){
    var projectBuffer = task.project.getDueDate() - task.project.getMinimumEndHour();
    var positiveProjectBuffer = Math.max(projectBuffer, 1);

    const remainingWork = task.totalWorkHours - task.currWorkedHours;
    const earliestStart = Math.round(task.startHour + task.currWorkedHours);
    const latestFinish = Math.round(task.startHour + remainingWork + positiveProjectBuffer);

    var load = remainingWork /// (latestFinish - earliestStart);

    return load;
}

function getAllFeatures(simulator) {
    var allFeatures = [];

    simulator.projectPool.projects.forEach(project => {
        project.getReadyToStartTasks().forEach(task => {
            allFeatures.push(getFeatures(task, simulator));
        });
    });

    return allFeatures;
}

function calculateTaskPriority(task, simulator) {
    var features = getFeatures(task, simulator);
    
    var projectPriority = 0;
    var resourcePriority = 0;
    
    var weights = StrategyManager.getParameters("Features");
    for (var feature in features.project) {
        if(weights[feature] == null) continue;
        // console.log(feature, features.project[feature], weights[feature]);
        projectPriority += features.project[feature] * weights[feature];
    }
    for (var groupID in features.resource) {
        resourcePriority += features.resource[groupID] * weights["increaseImportance"];
    }
    var priority = projectPriority + resourcePriority;
    // console.log(task.project.projectIndex, projectPriority, resourcePriority, priority);
    return priority;
}

function getFeaturePriority(simulator) {
    //Sim16 values
     StrategyManager.setParameters("Features", {projectRemainingBufferRatio: 10, increaseImportance: 0.001171});

    var readyTasks = simulator.projectPool.getAllReadyTasks(simulator.projectPool.projects);
    // / Calculate priorities for the tasks
    // calculateTaskPriority(readyTasks[0], simulator);
    // calculateTaskPriority(readyTasks[1], simulator);
    // calculateTaskPriority(readyTasks[2], simulator);
    // calculateTaskPriority(readyTasks[3], simulator);

    //Get the priorities in a dict with the taskID as key
    var priorities = {};
    readyTasks.forEach(task => {
        priorities[task.getUniqueID()] = calculateTaskPriority(task, simulator);
    });

    // return [];
    readyTasks.sort((task1, task2) => {
        var task1Priority = priorities[task1.getUniqueID()];
        var task2Priority = priorities[task2.getUniqueID()];

        return task1Priority - task2Priority || task1.project.projectIndex - task2.project.projectIndex;
    });

    return readyTasks;
}

module.exports = { getAllFeatures, getFeatures, getFeaturePriority, calculateTaskPriority }